import socket from "../api/socket";

export const LogUser = ({action,page,description,date = (+new Date)}) => {
    socket.emit('user_action', {
        token: localStorage.getItem('token'),
        action,
        description,
        page,
        date
    })
}

